<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2022-01-24 15:22:14
 * @LastEditors: mrh
 * @LastEditTime: 2022-05-20 09:24:47
-->
<template>
  <div class="schoolAgreement agreement49" v-if="type==49">
    <h2 style="text-align: center;">MassAI平台用户隐私政策</h2>
<p>&nbsp;</p>
<p><strong>更新日期：2025年09月18日</strong></p>
<p style="padding:10px 0"><strong>生效日期：2025年09月20日</strong></p>
<p><strong>【特别提示】本平台运营方&ldquo;广东禧越网络科技有限公司&rdquo;（以下简称&ldquo;我们&rdquo;），将按照法律法规的相关规定，保护您的个人隐私。请仔细阅读《平台用户隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的收集与处理（包括使用、保存、共享、转让）规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询。当您以适当的方式开始、继续使用我们的产品或服务超过15日的，您未通过适当的方式联系我们并表达相反意见的，我们将视为您充分理解并同意本政策。</strong></p>
<p>引言</p>
<p>本《隐私政策》适用于&ldquo;MassAI平台&rdquo;（以下简称&ldquo;平台&rdquo;）用户隐私协议。&ldquo;广东禧越网络科技有限公司&rdquo;（&ldquo;我们&rdquo;）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和处理您的相关信息。我们希望通过《平台用户隐私政策》（&ldquo;本隐私政策&rdquo;）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</p>
<p><strong>本政策将帮助您了解以下内容：</strong></p>
<p><strong>一、 我们如何收集和使用您的个人信息</strong></p>
<p><strong>二、 我们如何使用 Cookie 和同类技术</strong></p>
<p><strong>三、 我们如何共享、转让、公开披露您的个人信息</strong></p>
<p><strong>四、 我们如何保护和保存您的个人信息</strong></p>
<p><strong>五、 您如何管理个人信息</strong></p>
<p><strong>六、 通知和修订</strong></p>
<p><strong>七、 未成年人的个人信息保护</strong></p>
<p><strong>八、 免责声明（非常重要，请仔细阅读）</strong></p>
<p>&nbsp; &nbsp;</p>
<p><strong>本隐私政策与您所使用的平台服务以及该服务所包括的各种业务功能（以下统称&ldquo;我们的产品与/或服务&rdquo;）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务超过15日的，您未通过适当的方式联系我们并表达相反意见的，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集和处理您的相关信息。</strong></p>
<p><strong>如对本隐私政策或相关事宜有任何问题、异议、评论、建议、担忧、投诉或举报，您可随时通过官方客服与我们联系 。</strong></p>
<p><strong>&nbsp;</strong></p>
<p>“MassAI”的产品/服务是广东禧越网络科技有限公司（注册地址：惠州市江北文昌一路7号华贸大厦1单元10层7号）提供者通过下述途径向您提供的产品/服务：包括但不限于MassAIApp等客户端以及相关微信开放平台账号或小程序等。</p>
<p><strong>请您注意，本政策不适用于您通过我们的产品/服务而接入的其他第三方产品/服务(“其他第三方”，包括您的交易相对方、任何第三方网站以及第三方服务提供者等)，具体规定请参照该第三方的隐私政策或类似声明。</strong></p>
<p><strong>&nbsp;</strong></p>
<p><strong>一、我们如何收集和使用您的个人信息</strong></p>
<p><strong>1.1 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括但不限于：基本信息；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、wifi的ssid、读取WIFI扫描结果、<span class="text-only">wifi的</span><span class="text-only text-with-abbreviation text-with-abbreviation-bottomline windows-bottomline">BSSID、</span>SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）。</strong></p>
<p><strong>1.2 平台仅会出于以下目的，收集和使用您的个人信息：</strong></p>
<p><strong>1.2.1您须授权我们收集和使用您个人信息的情形:我们的产品与/或服务包括核心业务功能和附加功能，其中，核心功能包含了实现网上购物所必须的功能、改进我们的产品与/或服务所必须的功能及保障交易安全所必须的功能。我们可能会收集和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的核心产品与/或服务。</strong></p>
<p><strong>1.2.2这些功能包括：</strong></p>
<p><strong>1.2.2.1用户注册</strong></p>
<p>您首先需要注册一个我们平台账户成为我们用户。当您注册时，您需要至少向我们提供您准备使用的我们平台账户名、密码、您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效。您的账户名为您的默认昵称，您可以修改补充您的昵称、性别、生日相关信息，这些信息均属于您的&ldquo;账户信息&rdquo;。您补充的账户信息将有助于我们为您提供个性化的商品推荐和更优的购物体验，以上信息属于敏感信息，但如果您不提供这些补充信息，不会影响您网上购物的基本功能。</p>
<p><strong>1.2.2.2 基于位置信息的个性化推荐功能.</strong></p>
<p>我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您推荐您所在区域可以购买商品或服务的第三方商户。</p>
<p>上述功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在您设备设置中进行查看。请您注意，您开启上述权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与上述授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</p>
<p><strong>1.2.2.3 商品信息展示和搜索</strong></p>
<p>为了让您快速地找到您所需要的商品，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、浏览器类型来为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</p>
<p>您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品。 请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。</p>
<p><strong>1.2.2.4下单</strong></p>
<p>当您准备对您购物车内的商品进行结算时，我们系统会生成您购买该商品的订单。您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、您应支付的货款金额及支付方。</p>
<p>上述所有信息构成您的&ldquo;订单信息&rdquo;，我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。</p>
<p><strong>1.2.2.5 支付功能</strong></p>
<p>在您下单后，您可以选择我们的关联方或与我们合作的第三方支付机构（包括支付宝支付、微信支付，以下称&ldquo;支付机构&rdquo;）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的我们订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。&ldquo;关联方&rdquo;指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。&ldquo;控制&rdquo;是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。</p>
<p><strong>1.2.2.6 交付产品或服务功能</strong></p>
<p>在当您下单并完成支付后，与我们合作的第三方将为您完成订单的交付。您知晓并同意我们的关联方或与我们合作的第三方配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。</p>
<p><strong>1.2.2.7 客服与售后功能</strong></p>
<p>我们的客服和售后功能会使用您的账号信息和订单信息。</p>
<p>为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更配送地址、联系人或联系电话。</p>
<p><strong>1.2.3 改进我们的产品与/或服务所必须的功能</strong></p>
<p>我们可能会收集您的订单信息、浏览信息进行数据分析以形成用户画像，用来将您感兴趣的商品或服务信息展示给您；或在您搜索时向您展示您可能希望找到的商品。我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。</p>
<p><strong>1.2.4 保障交易安全所必须的功能</strong></p>
<p>为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的浏览信息、订单信息、您常用的软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接（&ldquo;URL&rdquo;）；我们也会收集您的设备信息对于我们系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</p>
<p><strong>1.3 您可选择是否授权我们收集和使用您的个人信息的情形</strong></p>
<p><strong>1.3.1为使您购物更便捷，从而提升您在我们的购物体验，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用附加功能或在购买某些商品时需要重复填写一些信息。这些附加功能包括：</strong></p>
<p>（a）基于摄像头（相机）的附加功能：您可以使用这个附加功能完成视频拍摄、拍照、扫码登录、人脸识别等功能。未来我们可能会将人脸识别技术应用于更多场景，但那时我们会再次与您确认您是否愿意我们使用您的面部信息来实现这些附加功能。</p>
<p>（b）基于图片上传的附加功能：您可以在平台上传您的照片来实现晒单及评价功能，我们会使用包含您所上传图片的评价。</p>
<p>（c）基于语音技术的附加功能：您可以直接使用麦克风来进行语音购物或与我们的客服机器人进行咨询和互动。在这些功能中我们会收集您的录音内容以识别您购物需求和客服与售后需求。</p>
<p><strong>1.3.2 上述附加功能可能需要您在您的设备中开启您的相机（摄像头）、相册（图片库）、麦克风以及通讯录的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在您设备设置中进行查看。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</strong></p>
<p><strong>1.4 您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</strong></p>
<p><strong>1.4.1 与国家安全、国防安全有关的；</strong></p>
<p><strong>1.4.2 与公共安全、公共卫生、重大公共利益有关的；</strong></p>
<p><strong>1.4.3 与犯罪侦查、起诉、审判和判决执行等有关的；</strong></p>
<p><strong>1.1.4 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</strong></p>
<p><strong>1.4.5 所收集的个人信息是个人信息主体自行向社会公众公开的；</strong></p>
<p><strong>1.4.6 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</strong></p>
<p><strong>1.4.7 根据您的要求签订合同所必需的；</strong></p>
<p><strong>1.4.8 用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</strong></p>
<p><strong>1.4.9 为合法的新闻报道所必需的；</strong></p>
<p><strong>1.4.10 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</strong></p>
<p><strong>1.4.11 法律法规规定的其他情形。</strong></p>
<p><strong>1.5 我们从第三方获得您个人信息的情形</strong></p>
<p><strong>1.5.1我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的我们账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</strong></p>
<p><strong>1.5.2需要向您特别说明的是，如您已拥有我们平台的用户账号，您可直接使用账号登陆，您同意并理解，通过我们的账号登陆方式使用服务时，我们将获取您账号的基本信息，包括账户名、密码、您本人的手机号码、电子邮箱地址。如您未注册过我们平台的用户账户，我们会将您在平台的注册账户与平台账户系统进行自动绑定，并将您在平台的账户名、密码、您的注册手机号码、电子邮箱地址与我们平台进行共享。</strong></p>
<p><strong>&nbsp;1.6 您个人信息使用的规则</strong></p>
<p><strong>1.6.1 我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</strong></p>
<p><strong>1.6.2 在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong></p>
<p><strong>1.6.3 请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将根据法律法规的规定停止使用并删除您的个人信息。</strong></p>
<p><strong>1.6.4 我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</strong></p>
<p>&nbsp;</p>
<p><strong>二、我们如何使用 Cookie 和同类技术</strong></p>
<p><strong>2.1 Cookies的使用</strong></p>
<p><strong>2.1.1 为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies 是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品等数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。</strong></p>
<p><strong>2.1.2 我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问我们时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</strong></p>
<p>&nbsp;</p>
<p><strong>三、我们如何共享、转让、公开披露您的个人信息</strong></p>
<p><strong>3.1 共享</strong></p>
<p><strong>3.1.1 我们不会与我们以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</strong></p>
<p><strong>3.1.1.1事先获得您明确的同意或授权；</strong></p>
<p><strong>3.1.1.2根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；</strong></p>
<p><strong>3.1.1.3 在法律法规允许的范围内，为维护我们、我们的关联方或合作伙伴、您或其他我们用户或社会公众利益、财产或安全免遭损害而有必要提供；</strong></p>
<p><strong>3.1.1.4 只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；</strong></p>
<p><strong>3.1.1.5 应您需求为您处理您与他人的纠纷或争议；</strong></p>
<p><strong>3.1.1.6 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</strong></p>
<p><strong>3.1.1.7 基于学术研究而使用；</strong></p>
<p><strong>3.1.1.8 基于符合法律法规的社会公共利益而使用。</strong></p>
<p><strong>3.1.2 我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</strong></p>
<p><strong>请您注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息（包括身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息、14岁以下（含）儿童的个人信息等。）。请您共享时谨慎考虑并决定。</strong></p>
<p><strong>3.1.3 我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括以下类型：</strong></p>
<p>(a) 商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供基础设施技术服务、信息服务、支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心购物功能，比如我们必须与配送信息平台以及商品的实际配送员共享您的订单信息才能确保实际配送员可以为您送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。</p>
<p>(b) 第三方商家。我们会将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。第三方商家可能会基于获取的上述信息，向您推送他们的广告信息，我们会要求第三方商家根据法律法规的要求设置相应的退订方式，您可根据第三方商家提供的退订方式，自主决定是否接收第三方商家的广告信息。</p>
<p>(c) 委托我们进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。我们可能会使用您的个人信息以及您的非个人信息集合形成的间接用户画像与委托我们进行推广的合作伙伴（&ldquo;委托方&rdquo;）共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。</p>
<p><strong>3.1.4 对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照平台 &nbsp;&nbsp;的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</strong></p>
<p><strong>3.1.5 为了遵守法律、执行或适用平台的使用条件和其他协议，或者为了保护平台、您或其他我们客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</strong></p>
<p><strong><br/></strong></p>
<p style="padding-bottom: 10px;">
  <strong>关于嵌入第三方代码、插件的特别说明</strong>
</p>

针对本平台目前嵌入第三方代码、插件的情形，我们将向您逐项列举如下：<br/>
SDK名称：友盟社会化分享SDK<br/>
所属机构：友盟同欣（北京）科技有限公司<br/>
使用场景：第三方授权登录、内容分享<br/>
收集的个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/地理位置等）、应用列表<br/>
<p>SDK官方隐私政策链接：<a href="https://www.umeng.com/page/policy" >https://www.umeng.com/page/policy</a></p><br/>
<p><strong></strong></p>

SDK名称：友盟统计分析 SDK<br/>
所属机构：友盟同欣（北京）科技有限公司<br/>
使用场景：用户行为数据、App 运营数据的采集与可视化分析<br/>
使用目的：提供用户行为数据、App 运营数据的采集与可视化分析，帮助更好的分析决策实现业务增长<br/>
收集个人信息类型： 设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等）<br/>
<p>SDK官方隐私政策链接：<a href="https://www.umeng.com/page/policy" >https://www.umeng.com/page/policy</a></p><br/>
<p><strong></strong></p>
SDK名称：友盟应用性能监控平台U-APM SDK<br/>
所属机构：友盟同欣（北京）科技有限公司<br/>
使用场景：App稳定性监控， 崩溃问题追踪<br/>
使用目的：提供App稳定性监控， 崩溃问题追踪服务<br/>
收集个人信息类型： 个人信息字段采集：我们采集设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/地理位置等），用于唯一标识设备，以便提供设备应用性能监控服务；通过采集位置信息提供反作弊服务，剔除作弊设备，排查应用性能崩溃原因<br/>
<p>SDK官方隐私政策链接：<a href="https://www.umeng.com/page/policy" >https://www.umeng.com/page/policy</a></p><br/>
<p><strong></strong></p>
SDK名称：上传SDK<br/>
所属机构：阿里云计算有限公司<br/>
使用场景：上传视频<br/>
收集的个人信息类型：UUID、设备型号、IP地址<br/>
<p>SDK官方隐私政策链接：<a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html</a></p><br/>
<p><strong></strong></p>
SDK名称：百度地图SDK<br/>
所属机构：北京百度网讯科技有限公司<br/>
使用场景：展示所在位置<br/>
收集的个人信息类型：设备信息（包括Android ID、IDFV、操作系统版本、设备品牌及型号、设备配置、应用信息（应用名）、陀螺仪角度）、<br/>
位置信息【可能包括经纬度、设备信号强度信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、<br/>
位置信息（可能包括GNSS信息、WiFi地址及信号强度信息、基站ID数据信息、传感器信息、设备信号强度信息、IP地址和蓝牙信息）、<br/>
网络状态（如移动网络、WiFi网络或无网状态）、图像信息<br/>
<p>SDK官方隐私政策链接：<a href="https://lbs.baidu.com/index.php?title=openprivacy">https://lbs.baidu.com/index.php?title=openprivacy</a></p><br/>
<p><strong></strong></p>
SDK名称：百度定位SDK<br/>
所属机构：北京百度网讯科技有限公司<br/>
使用场景：展示所在位置<br/>
收集的个人信息类型：设备信息【包括设备标识信息（Android ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）】、<br/>
位置信息【可能包括经纬度、GNSS信息、WiFi网关地址、WiFi MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、网络类型【如移动网络、WiFi网络】<br/>
<p>SDK官方隐私政策链接：<a href="https://lbs.baidu.com/index.php?title=openprivacy">https://lbs.baidu.com/index.php?title=openprivacy</a></p><br/>

<p><strong></strong></p>
SDK名称：微信开放平台（TencentOpenSDK）<br/>
所属机构：腾讯科技（深圳）有限公司<br/>
使用场景：微信登录<br/>
收集的个人信息类型：设备标识信息（Android ID）、设备参数及系统信息（设备型号、操作系统）、网络相关信息（IP地址、网络运营商）、已安装应用包名信息<br/>
<p>SDK官方隐私政策链接：<a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a></p><br/>


<p><strong></strong></p>
SDK名称：极光推送 SDK<br/>
所属机构：深圳市和讯华谷信息技术有限公司<br/>
使用场景：为 APP 用户提供信息推送服务<br/>
处理个人信息类型及用途：设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、WIFI状态信息）、推送信息日志：必要个人信息，用于推送服务基本业务功能场景中生成脱敏的终端用户设备唯一性标识，保证服务在不同设备上的兼容性和准确识别，同时了解推送信息送达的情况。设备标识符（包括IMEI、MAC、IMSI）：可选个人信息，用于推送服务基本业务功能场景中生成终端用户设备唯一标识的补充，提升唯一设备标识的准确性，进而提升推送的精确度和触达率；网络信息（包括SSID、BSSID、WIFI列表信息、基站信息）：可选个人信息，用于推送服务基本业务功能场景中判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。位置相关信息：地理围栏、用户分群推送扩展功能所必要个人信息，用于提供线下场景的精细化推送，根据位置信息推荐更符合您需要的推送内容；软件列表信息（包括软件列表及软件运行列表信息）：用户分群、应用自启动、链路调节器扩展功能所必要个人信息：有助于帮助您洞察您终端用户的兴趣偏好，帮助您为用户提供更合适的推送内容，同时优化SDK长连接稳定性，提升推送送达率及应用活跃度及通过合并链路，达到为用户省电省流量的目的。<br/>
数据处理方式：通过去标识化、加密传输及其他安全方式<br/>
<p>SDK官方隐私政策链接：<a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></p><br/>
<p><strong></strong></p>

<p><strong>3.2 转让</strong></p>
<p><strong>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</strong></p>


<p><strong>3.2.1 事先获得您明确的同意或授权；</strong></p>
<p><strong>3.2.2 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</strong></p>
<p><strong>3.2.3 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</strong></p>
<p><strong>3.2.4 在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</strong></p>
<p><strong>3.3 公开披露</strong></p>
<p><strong>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：</strong></p>
<p><strong>3.3.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</strong></p>
<p><strong>3.3.2 根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。</strong></p>
<p>&nbsp;</p>
<p><strong>四、我们如何保护和保存您的个人信息</strong></p>
<p><strong>4.1 我们保护您个人信息的技术与措施</strong></p>
<p><strong>4.2 我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</strong></p>
<p><strong>4.2.1 我们会采取适当的、符合业界标准的安全措施和技术手段，以保护您的个人信息，包括但不限于制定了严格的内部信息管理流程、对数据进行加密、定岗定责、举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识、控制访问权限、采取安全措施等，以防止其丢失、被非法使用、受到未授权访问或泄漏、被篡改或毁坏。</strong></p>
<p><strong>4.2.2 我们仅允许有必要知晓这些信息的平台及平台关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。</strong></p>
<p><strong>4.2.3 为了保护您的信息安全，如果您的个人信息有误，我们会在严格验证并核实申请人身份后，根据您的要求访问、修正或删除相关信息（除非我们出于合法的原因而必须保留这些个人信息）。</strong></p>
<p><strong>4.2.4 如果一旦发生安全事件影响到您的个人信息安全的，我们将通过您预留的邮箱、电话、系统推送等方式通知您，并告知您降低或防范相关风险的建议等信息。必要时，我们将根据适用的法律、法规通知主管部门。同时，我们会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。在发生危害网络安全的事件时，我们会按照网络安全事件应急预案，及时采取相应的补救措施，并按照规定向有关主管部门报告。</strong></p>
<p><strong>4.2.5&nbsp; 如果您对我们的个人信息保护有任何疑问，可通过本政策上的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策提供的联系方式联络我们，以便我们采取相应措施，我们的个人信息保护负责人联系方式：0752-2162293。</strong></p>
<p><strong>4.3 您个人信息的保存</strong></p>
<p><strong>4.3.1 您的个人信息将全被存储于中华人民共和国境内。</strong></p>
<p><strong>4.3.2 除非法律法规另有规定，您的个人信息我们将保存至您账号注销之日后的一个月。我们承诺这是为了保证您在我们购物的消费者权益，您个人信息在我们须保存的最短期间。当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。</strong></p>
<p><strong>4.3.3&nbsp;如果平台终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</strong></p>
<p><strong>4.3.4&nbsp;除非获得您的特别同意，或者满足法律规定的评估及许可程序，我们不会跨境转移您的个人信息。</strong></p>
<p>&nbsp;</p>
<p><strong>五、您如何管理您的个人信息</strong></p>
<p><strong>5.1我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</strong></p>
<p><strong>5.2 访问和更正您的个人信息:除法律法规规定外，您有权随时访问和更正您的个人信息（但使用第三方账号授权或关联登录的除外）、收货信息、订单信息、评论信息等。</strong></p>
<p><strong>5.3 您无法访问和更正的个人信息：除上述列明的信息外，您的部分个人信息平台还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用附加功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可联系我们进行删除或做匿名化处理。</strong></p>
<p><strong>5.4 删除您的个人信息:您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括订单信息、浏览信息、收货地址信息；</strong></p>
<p><strong>5.5 在以下情形中，您可以向我们提出删除个人信息的请求：</strong></p>
<p><strong>5.5.1 如果我们处理个人信息的行为违反法律法规；</strong></p>
<p><strong>5.5.2 如果我们收集、使用您的个人信息，却未征得您的同意；</strong></p>
<p><strong>5.5.3 如果我们处理个人信息的行为违反了与您的约定；</strong></p>
<p><strong>5.5.4 如果您注销了我们账户；</strong></p>
<p><strong>5.5.5 如果我们终止服务及运营。</strong></p>
<p><strong>5.6 若我们决定响应您的删除请求，我们还将同时通知从平台获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从平台的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</strong></p>
<p><strong>5.7 改变您授权同意的范围或撤回您的授权</strong></p>
<p><strong>5.7.1 您可以通过删除信息、关闭设备功能等方式改变您授权平台继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回平台继续收集您个人信息的全部授权。</strong></p>
<p><strong>5.7.2 请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</strong></p>
<p><strong>5.8 注销账户</strong></p>
<p><strong>5.8.1请您注意，如果您存在完成不满三个月的订单，可能需要您履行完毕后方可注销账户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</strong></p>
<p><strong>六、通知和修订</strong></p>
<p><strong>6.1 为给您提供更好的服务以及随着平台业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在平台网站、平台移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问平台以便及时了解最新的隐私政策。</strong></p>
<p><strong>6.2 对于重大变更，我们还会提供更为显著的通知（通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</strong></p>
<p><strong>本政策所指的重大变更包括但不限于：</strong></p>
<p><strong>6.2.1我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</strong></p>
<p><strong>6.2.2 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</strong></p>
<p><strong>6.2.3 个人信息共享、转让或公开披露的主要对象发生变化；</strong></p>
<p><strong>6.2.4 您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong></p>
<p><strong>6.2.5 平台负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</strong></p>
<p><strong>6.2.6 个人信息安全影响评估报告表明存在高风险时。</strong></p>
<p>&nbsp;</p>
<p><strong>七、未成年人的个人信息保护&nbsp;</strong></p>
<p><strong>7.1&nbsp;本平台非常重视对未成年人（包括儿童）个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。MassAI根据国家相关法律法规的规定保护未成年人的个人信息。</strong></p>
<p><strong>7.2 我们不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</strong></p>
<p><strong>7.3 如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。</strong></p>
<p><strong>7.4 对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：</strong></p>
<p><strong>（1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。</strong></p>
<p><strong>（2）当您作为监护人为被监护的儿童选择使用MassAI相关服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品与/或服务，您应正确引导并予以监护。</strong></p>
<p><strong>（3）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系我们。我们会随时为您提供帮助。</strong></p>
<p>&nbsp;</p>
<p><strong>八、免责声明</strong></p>
<p><strong>8.1 当您以适当的方式开始、继续使用我们的产品或服务超过15日的，您未通过适当的方式联系平台并表达相反意见的，我们将视为您充分理解并同意本政策。</strong></p>
<p><strong>8.2 请您理解，互联网并非绝对安全的环境，电子邮件、即时通讯、社交软件、交易平台等与其他用户的交流方式无法确定是否完全加密，请您在进行交互使用时，注意保护您个人信息的安全。</strong></p>
<p><strong>8.3 请您理解，由于计算机及互联网技术的飞速发展及同步速度的限制，可能存在或出现各种恶意或非恶意的攻击手段。虽然平台持续致力于提升和加强安全措施，以保护您的个人信息免遭意外或破坏，但仍无法始终保证您的个人信息的百分之百安全。</strong></p>
<p><strong>8.4 请您理解，您使用产品或服务时所用的系统和通讯网络，或硬件设备等我们均无法控制，请您了解并注意保护您的个人信息安全。除非本隐私政策有其他规定，为了保护您的人身及财产安全，我们特别提醒您不要通过公共网络，向我们或任何以我们名义为您提供服务的第三方，提供您的财产状况、健康生理、账户密码或验证码、个人轨迹、通信内容等信息。</strong></p>
<p>&nbsp;</p>
<p><strong>特别提示：本《平台用户隐私政策》将于发布之日正式生效，除非平台根据相关法律法规及平台运营对本疑似政策作出调整并发布新的隐私政策，否则本隐私政策一直有效。</strong></p>

  </div>
  <div v-else class="schoolAgreement" v-html="content"></div>
</template>

<script>
import { getActivityRuleContent } from "@/api/join";
export default {
  data() {
    return {
      content: "",
      type:''
    };
  },
  mounted() {
    if(this.GetQueryString("type")==49){
      this.type = 49;
      return;
    }
    getActivityRuleContent({ type: this.GetQueryString("type") || "20" }).then(
      (res) => {
        if (res.appStatus.errorCode == 0) {
          this.content = res.content.content;
        }
      }
    );
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/registerAgreement") {
      let title;
      to.meta.hiddenHeader = false;
      switch (to.query.type) {
        case "26": case "47":
          title = "注册协议";
          break;
        case "25": case "49":
          title = "隐私政策协议";
          break;
        default:
          break;
      }
      to.meta.title = title;
      document.title = title;
      // console.log(to,'1')
      // to.meta.hiddenHeader = false;
      // if (to.query.type == '26') {
      //   to.meta.title = "注册协议";
      // }else if(to.query.type == '25'){
      //   to.meta.title = "隐私政策协议"
      // }
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.schoolAgreement {
  font-size: 12px;
  padding:0 14px
}
.agreement49 {
  text-align: justify;
  line-height: 1.5;
}
h2 {
  text-align: center;
  padding: 20px 0;
}
.text-right {
  text-align: right;
  line-height: 2;
}
.weight {
  font-weight: bold;
}
.line-height18 {
  line-height: 1.8;
}
p{
  word-break: break-word; /* 或者选择其他合适的值 */
  overflow-wrap: break-word; /* 确保长单词能够换行 */
  white-space: normal; /* 确保文本可以在需要的地方自动换行 */
}
</style>